import { useSyncExternalStore } from 'react';
import { userUserDetailsScopesStore } from './user-user-details-scopes-store';
const useUserDetails = () => {
    const userDetailsScopes = useSyncExternalStore(userUserDetailsScopesStore.subscribe, userUserDetailsScopesStore.getSnapshot);
    return {
        userDetailsScopes: userDetailsScopes.userDetailsDataScopes,
        setUserDetailsScopes: userUserDetailsScopesStore.setUserDetailsScopes,
    };
};
export { useUserDetails };
